"use client";
import { useTranslations } from 'next-intl';
import style from './auth.module.scss';
import { useEffect, useState } from 'react';
import Button from '../form-elements/button/Button';
import Registration from './partials/registration/Registration';
import Login from './partials/login/Login';
import { useApiClient } from '@/projectRoot/src/contexts/ApiClientContext';

interface Props {
    setHeadTitle: (title: string) => void;
    classes?: string[];
}

const Auth = ({ setHeadTitle, classes = []}: Props) => {
    const t = useTranslations();
    const [showRegistration, setShowRegistration] = useState<boolean>(false);

    const toggleWindow = (show: boolean) => {
        setShowRegistration(show);
    }

    useEffect(() => {
        setHeadTitle(t(showRegistration ? 'create_account' : 'login'));
    }, [showRegistration]);

  return (
    <aside className={`${style.auth} ${classes.join(' ')}`}>
        <p className={style.question}>
            {t(!showRegistration ? 'are_you_new_customer' : 'are_you_existing_customer')}
        </p>
        <Button 
            classes={[style.flowSwitcher]} 
            label={t(!showRegistration ? 'create_account' : 'login')}
            onClick={() => toggleWindow(!showRegistration)}
        />
        {
            showRegistration
            ?
            <Registration />
            :
            <Login setHeadTitle={setHeadTitle} />
        }
    </aside>
  )
};

export default Auth;
